import type { StylesConfig, GroupBase } from "react-select";
import { IDropdownOption } from "../interfaces/iDropdown.interface";

/** Create a StylesConfig bound to the specific option type TOption */
export const createSelectStyles = <
  TOption extends IDropdownOption
>(): StylesConfig<TOption, false, GroupBase<TOption>> => ({
  control: (base, state) => ({
    ...base,
    borderRadius: 12,
    borderColor: state.isFocused ? "#BFDBFE" : "#E5E7EB",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(59,130,246,0.15)" : "none",
    padding: "2px",
    minHeight: "44px",
    backgroundColor: "white",
    ":hover": { borderColor: state.isFocused ? "#BFDBFE" : "#D1D5DB" },
  }),
  valueContainer: (b) => ({ ...b, padding: "0 8px" }),
  placeholder: (b) => ({ ...b, color: "#9CA3AF" }),
  input: (b) => ({ ...b }),
  singleValue: (b) => ({ ...b }),
  menu: (b) => ({ ...b, borderRadius: 12, overflow: "hidden" }),
  option: (b, s) => ({
    ...b,
    backgroundColor: s.isFocused ? "rgba(59,130,246,0.08)" : "white",
    color: "#111827",
    cursor: "pointer",
  }),
  indicatorsContainer: (b) => ({ ...b }),
});
